export const ADD_WORKSPACE = 'ADD_WORKSPACE';
export const DELETE_WORKSPACE = 'DELETE_WORKSPACE';
export const RESET_WORKSPACE = 'RESET_WORKSPACE';

export const SELECT_SPACE = 'SELECT_SPACE';

export const ADD_LIST = 'ADD_LIST';
export const DELETE_LIST = 'DELETE_LIST';

export const ADD_TODO = 'ADD_TODO';
export const DELETE_TODO = 'DELETE_TODO';

export const MARK_AS_DONE = 'MARK_AS_DONE';
export const CLEAR_COMPLETED = 'CLEAR_COMPLETED';
